import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { Grid } from '@components/Grid';
import Loader from '@components/Loader';

const Editor = ({ user, website }) => {
    const [loading, setLoading] = useState(true);
    // const [pages, setPages] = useState([]);

    useEffect(() => {
    }, []);

    // if (loading) return <Loader />;

    return (
        <Grid>
            <h1>Store</h1>
        </Grid>
    );
};

export default connect(({ user, website }) => ({ user, website }))(Editor);
